import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import HeaderOfPage from '../tools/headerOfPage';
export default function EditBrand() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);

    const [data, setData] = React.useState<any>(null);
    const [activeLang, setActiveLang] = useState<string>('en');
    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/brands/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Update Data')
        } catch (error) {

        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/brands/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
                } else if (loadedData.name && loadedData.name.nl) {
                    // Migrate old nl to ku
                    loadedData.name.ku = loadedData.name.nl;
                    delete loadedData.name.nl;
                    if (!loadedData.name.tr) loadedData.name.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
                if (typeof loadedData.keywords === 'string' || !loadedData.keywords) {
                    loadedData.keywords = loadedData.keywords ? { ku: loadedData.keywords, fa: loadedData.keywords, en: loadedData.keywords, ar: loadedData.keywords, tr: loadedData.keywords } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.keywords && loadedData.keywords.nl) {
                    loadedData.keywords.ku = loadedData.keywords.nl;
                    delete loadedData.keywords.nl;
                    if (!loadedData.keywords.tr) loadedData.keywords.tr = '';
                }
            }
            setData(loadedData)
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'Brands List',
            url: '/dashboard/Products/Brands'
        },
        {
            name: 'Edit Brand',
            url: null
        }
    ]
    useEffect(() => {
        load();
    }, []);
    return (
        <div>
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="ویرایش برند"></HeaderOfPage>


            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5'>
                    <div >

                        <div className=" bg-black rounded-[10px] p-5 text-right">
                            <div className='mt-3'>
                                <div className="text-white text-right">{t('Thumpnail')}  </div>
                                <ImageUploader id={data.id} component={'brands'}></ImageUploader>
                            </div>
                            <form key={key}>
                                {/* Language Selector */}
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">زبان / Language</label>
                                    <div className="flex gap-2 flex-wrap">
                                        {languages.map((lang) => (
                                            <button
                                                key={lang.code}
                                                type="button"
                                                onClick={() => setActiveLang(lang.code)}
                                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                                    activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                                }`}
                                            >
                                                {lang.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Name')} ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <input
                                        value={data.name?.[activeLang] || ''}
                                        type="text"
                                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Name"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            name: { 
                                                ...data.name, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white"> Slug </label>
                                    <input
                                        type="text"
                                        value={data.url || ''}
                                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                                        placeholder="Slug"
                                        onChange={(e) => setData({ ...data, url: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={data.keywords?.[activeLang] || ''}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            keywords: { 
                                                ...data.keywords, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Description')} ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={data.description?.[activeLang] || ''}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            description: { 
                                                ...data.description, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <button type="button"
                                        onClick={(e) => { save() }}
                                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                                    >{t('Update Category')}
                                    </button>

                                </div>
                            </form>



                        </div>
                    </div>
                    <div className='col-span-1 sm:col-span-4'>
                        <TissEditor component='brands' parent={data.id} />
                    </div>
                </div>
            }

        </div>
    )
}